@if (attachments?.length > 0) {
  <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 d-flex align-items-center documentation-attached-title">
    <fa-icon [icon]="faFolderOpen" class="documentation-attached-icon mr-2"></fa-icon>
    {{ "generic.documentation-attached" | translate }}
  </h4>
}

@for (attachment of attachments; track attachment; let i = $index) {
  <div>
    <div class="row justify-content-between">
      <span class="name col-9">
        <mat-icon class="attachment-type-icon mr-2 align-middle">
          {{ attachment.type === 'PUBMED' ? 'science' : (attachment.type === 'LINK' ? 'link' : 'insert_drive_file') }}
        </mat-icon>
        <a [href]="attachment.link" target="_blank" class="align-middle">{{
          attachment.title
        }}</a>
      </span>
      @if (editable) {
        <span class="col-2 align-middle mt-auto mb-auto" (click)="deleteAttachment(i)">
          {{ "generic.buttons.delete" | translate }}
          <i class="icon-cestino main-color ml-1"></i>
        </span>
      }
    </div>
  </div>
}

@if (buttonToAdd && editable) {
  <div class="row justify-content-center">
    <button mat-button class="allega-evidenze-btn" [matMenuTriggerFor]="menuAttachment">
      <i class="icon-upload mr-2"></i>
      {{ 'components.responses.add-evidences' | translate }}
    </button>
    <mat-menu #menuAttachment="matMenu">
      <button mat-menu-item (click)="onClickAddNewEvidence('PUBMED')">
        <mat-icon aria-hidden="false" class="attachment-evidence-icon">science</mat-icon>
        Pubmed
      </button>
      <button mat-menu-item (click)="onClickAddNewEvidence('FILE')">
        <mat-icon aria-hidden="false" class="attachment-evidence-icon">insert_drive_file</mat-icon>
        File
      </button>
      <button mat-menu-item (click)="onClickAddNewEvidence('LINK')">
        <mat-icon aria-hidden="false" class="attachment-evidence-icon">link</mat-icon>
        Link
      </button>
    </mat-menu>
  </div>
}
